import type { TicketEstado, TicketPrioridad, TicketTipo } from '@zonasocioscofarte/types'
import { fetchFromApi } from '@utils/apiOrigin'

export const TIPO_LABELS: Record<TicketTipo, string> = {
  problema: 'Problema',
  sugerencia: 'Sugerencia',
  duda: 'Duda'
}

export const PRIORIDAD_LABELS: Record<TicketPrioridad, string> = {
  baja: 'Baja',
  media: 'Media',
  alta: 'Alta'
}

export const ESTADO_LABELS: Record<TicketEstado, string> = {
  abierto: 'Abierto',
  en_proceso: 'En proceso',
  resuelto: 'Resuelto',
  cerrado: 'Cerrado'
}

export function formatFechaHora(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

export async function downloadTicketAttachment(path: string, fileName: string, headers: Record<string, string>): Promise<void> {
  const res = await fetchFromApi(path, { headers })
  if (!res.ok) throw new Error(`No se pudo descargar el adjunto (HTTP ${res.status})`)
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function getTicketAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('ecofarte_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export function getTicketAdminHeaders(): Record<string, string> {
  const token = localStorage.getItem('ecofarte_admin_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}
